import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {TmtErpPanelFilterService} from '../../service/tmt-erp-panel-filter.service';
import {TmtErpPanelFilterModel} from '../../models/tmt-erp-panel-filter-model';

@Component({
  selector: 'app-tmt-erp-filter-modal',
  imports: [
    MatButton,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './tmt-erp-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
})
export class TmtErpFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<TmtErpFilterModalComponent>);
  private readonly filterService = inject(TmtErpPanelFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;

  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const filters = this.filterService.filtersValue();
    this.form.patchValue({
      SalesOrderId: filters.SalesOrderId,
      TripReference: filters.TripReference,
      ErpOrderNumber: filters.ErpOrderNumber,
      ClientName: filters.ClientName,
      CreatedDateFrom: filters.CreatedDateFrom,
      CreatedDateTo: filters.CreatedDateTo,
      ErpSentDateFrom: filters.ErpSentDateFrom,
      ErpSentDateTo: filters.ErpSentDateTo,
      ErpResponseDateFrom: filters.ErpResponseDateFrom,
      ErpResponseDateTo: filters.ErpResponseDateTo,
      IsFailed: filters.IsFailed,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: TmtErpPanelFilterModel = {
      SalesOrderId: raw.SalesOrderId,
      TripReference: raw.TripReference,
      ErpOrderNumber: raw.ErpOrderNumber,
      ClientName: raw.ClientName,
      CreatedDateFrom: raw.CreatedDateFrom,
      CreatedDateTo: raw.CreatedDateTo,
      ErpSentDateFrom: raw.ErpSentDateFrom,
      ErpSentDateTo: raw.ErpSentDateTo,
      ErpResponseDateFrom: raw.ErpResponseDateFrom,
      ErpResponseDateTo: raw.ErpResponseDateTo,
      IsFailed: raw.IsFailed,
      ReloadGrid: true,
    };
    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      SalesOrderId: null,
      TripReference: null,
      ErpOrderNumber: null,
      ClientName: null,
      CreatedDateFrom: null,
      CreatedDateTo: null,
      ErpSentDateFrom: null,
      ErpSentDateTo: null,
      ErpResponseDateFrom: null,
      ErpResponseDateTo: null,
      IsFailed: null,
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
